import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  takeHoldemSeatService,
  takeHoldemActionService,
  updateHoldemPlayerSittingStatusService,
  updateHoldemPlayerSitOutNextBBService,
  updateHoldemBuyInAmountService,
  changeHoldemSeatService,
  getHoldemGameTablesService,
  runItTwiceDecisionService
} from 'network/services/holdemGameManagement.service'

export const getHoldemGameTablesThunk = createAsyncThunk(
  'holdem/getGameTables',
  async ({ data}, { rejectWithValue }) => {
    try {
      const response = await getHoldemGameTablesService(data)
      return response
    } catch (error) {
      return rejectWithValue('Failed to fetch game tables')
    }
  }
)

export const takeHoldemSeatThunk = createAsyncThunk(
  'holdem/takeSeat',
  async (data, { rejectWithValue }) => {
    try {
      const response = await takeHoldemSeatService(data)
      return response.data?.data || response.data
    } catch (error) {
      console.error('Error taking Holdem seat:', error)
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to take seat')
    }
  }
)

export const takeHoldemActionThunk = createAsyncThunk(
  'holdem/takeAction',
  async (data, { rejectWithValue }) => {
    try {
      const response = await takeHoldemActionService(data)
      return response.data?.data || response.data
    } catch (error) {
      console.error('Error taking Holdem action:', error)
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to take action')
    }
  }
)

export const updateHoldemPlayerSittingStatusThunk = createAsyncThunk(
  'holdem/updatePlayerSittingStatus',
  async (data, { rejectWithValue }) => {
    try {
      const response = await updateHoldemPlayerSittingStatusService(data)
      return response.data?.data || response.data
    } catch (error) {
      console.error('Error updating Holdem player sitting status:', error)
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to update sitting status')
    }
  }
)

export const updateHoldemPlayerSitOutNextBBThunk = createAsyncThunk(
  'holdem/updatePlayerSitOutNextBB',
  async (data, { rejectWithValue }) => {
    try {
      const response = await updateHoldemPlayerSitOutNextBBService(data)
      return response.data?.data || response.data
    } catch (error) {
      console.error('Error updating Holdem player sit out next BB:', error)
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to update sit out next BB')
    }
  }
)

export const updateHoldemBuyInAmountThunk = createAsyncThunk(
  'holdem/updateBuyInAmount',
  async (data, { rejectWithValue }) => {
    try {
      const response = await updateHoldemBuyInAmountService(data)
      return response.data?.data || response.data
    } catch (error) {
      console.error('Error updating Holdem buy-in amount:', error)
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to update buy-in amount')
    }
  }
)

export const changeHoldemSeatThunk = createAsyncThunk(
  'holdem/changeSeat',
  async (data, { rejectWithValue }) => {
    try {
      const response = await changeHoldemSeatService(data)
      return response.data?.data || response.data
    } catch (error) {
      console.error('Error changing Holdem seat:', error)
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to change seat')
    }
  }
)

export const runItTwiceDecisionThunk = createAsyncThunk(
  'holdem/runItTwiceDecision',
  async (data, { rejectWithValue }) => {
    try {
      const response = await runItTwiceDecisionService(data)
      return response.data?.data || response.data
    } catch (error) {
      console.error('Error submitting run it twice decision:', error)
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to submit decision')
    }
  }
)
